export default "__VITE_ASSET__CEz7JnaB__"